import React, { useState, useEffect } from "react";
import $ from "jquery";

import { useParams } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import _ from "lodash";

import { Select, Drawer } from "antd";

import { useHistory } from "react-router-dom";
import Loader from "../../../../../components/loader";
import DisplayFlowNodes from "./DisplayFlowNodes";
import ProcessAction from "./ProcessAction";
import errorIcon from "../../../../../images/404-Error-pana.svg";
import unauthorizedIcon from "../../../../../images/403-Error-pana.png";
import { addToCompare } from "../../../../../redux/actions/skill";
const { Option } = Select;

const CompareFlow = () => {
  useEffect(() => {
    $(".sidebar-global").hide();
    $(".process-sidebar").hide();
    return () => {
      $(".sidebar-global").show();
      dispatch(addToCompare([]));
    };
  }, []);

  const dispatch = useDispatch();
  const history = useHistory();
  const params = useParams();

  const flows = useSelector((state) => state.skillReducer?.compareFlow);
  const flow2 = useSelector(
    (state) => state.skillReducer?.compareFlow[1]?.document
  );
  const loading = useSelector((state) => state.skillReducer.loading);
  const userRole = useSelector(
    (state) => state.organizationReducer?.currentOrgUser
  );
  const userSub = useSelector((state) => state.userReducer?.user?.sub);
  const userEmail = useSelector((state) => state.userReducer?.user?.email);
  const readOnly = useSelector((state) => state.skillReducer?.readOnly);
  const skillInfo = useSelector((state) => state.skillReducer?.compareFlow[0]);
  return (
    <div className="compare-page">
      <ProcessAction {...skillInfo} />
      <div className="compare-flows scrollable">
        {flows?.map((f) => (
          <>
            {f?.document?.actions.length ? (
              <>
                {" "}
                <DisplayFlowNodes {...f} />
              </>
            ) : null}
          </>
        ))}
      </div>
    </div>
  );
};

export default CompareFlow;
